import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { DateTime } from "luxon"

import DateTimeInput from "widgets/dates/DateTimeInput"

const DATE_FORMAT = "yyyy-MM-dd HH:mm"

interface InstalledAtInputProps {
  name: string
}

const InstalledAtInput = ({ name }: InstalledAtInputProps) => {
  const { control } = useFormContext()
  const { t } = useTranslation()

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        validate: (value) => {
          if (!value || value === "-") return true
          const date = DateTime.fromFormat(value as string, DATE_FORMAT)
          if (!date.isValid) return t("dates.INVALID_DATE")
          if (date > DateTime.now()) return t("dates.MAX_FUTURE")
          return true
        },
      }}
      render={({ field, fieldState: { error } }) => {
        const { onChange, value, ref } = field

        const dateValue =
          value && value !== "-"
            ? DateTime.fromFormat(value as string, DATE_FORMAT)
            : null

        return (
          <DateTimeInput
            inputRef={ref}
            value={dateValue?.isValid ? dateValue : null}
            onChange={(newValue) => {
              onChange(newValue?.isValid ? newValue.toFormat(DATE_FORMAT) : "")
            }}
            disableFuture
            error={!!error}
            helperText={error?.message}
          />
        )
      }}
    />
  )
}

export default InstalledAtInput
